import { FACILITY_AND_ANCILLARY_ACTIONS } from 'config';
import { setPriceCategoryList, setPriceDiffAvgChartList, transformData } from 'utils/helpers';
import { splitHospitalWiseData } from 'utils/helpers';

export const initialState = {
  payerList: {
    data: [],
    loading: false,
    error: null
  },

  filteredDRGList: {
    hospitalList: [],
    payerList: [],
    billingCodeType: [],
    billingCode: [],
    filterDrgListData: [],
    filteredDRGRawData: [],
    loading: false,
    error: null,
    ancillaryList: []
  },

  drgCostBreakDown: {
    allEntities: [],
    providerName: [],
    codeCategory: [],
    reportingEntityName: [],
    drgBreakdown: [],
    loading: false,
    error: null
  },
  payerProcCount: {
    data: [],
    loading: false,
    error: null
  },
  categoryList: {
    data: [],
    loading: false,
    error: null
  },
  selectedFilterDataPayers: {
    npiList: [],
    l1DescriptionList: [],
    procedureNameList: [],
    modifierList: [],
    codeTypeList: [],
    procCategoryList: [],
    hospitalList: [],
    ancillaryList: [],
    loading: false,
    error: null
  },
  priceDiffAvgList: {
    data: [],
    negotiatedTypes: [],
    error: null,
    loading: false,
    combinedPriceDiffList: []
  },
  stateMapDataList: {
    data: [],
    error: null,
    loading: false
  },
  regionalMapDataList: {
    data: [],
    error: null,
    loading: false
  },
  selectedState: { id: 'NY', properties: { name: 'New York' } },
  allPayers: {
    data: [],
    error: null,
    loading: false
  },
  topOverviewList: {
    categoryList: [],
    overviewList: [],
    topProcedures: [],
    topProceduresNotPref: [],
    topProceduresL4: [],
    toptopProceduresNotPrefL4: [],
    loading: false,
    error: null
  },
  historicalRequests: {
    data: [],
    loading: false,
    error: null
  },
  reRequest: {
    message: null,
    loading: false,
    error: null
  },
  facilityScoreCardScore: {
    data: [],
    loading: false,
    error: null
  },
  facilityScoreCardnpiData: {
    data: [],
    loading: false,
    error: null
  },
  providerExtractFilters: {
    data: [],
    loading: false,
    error: null
  },
  providerExtractResult: {
    data: [],
    loading: false,
    error: null
  },
  providerExtractChartResult: {
    data: [],
    loading: false,
    error: null
  }
};

const ancillaryAndFacility = (state = initialState, action) => {
  switch (action.type) {
    //PAYER LIST REDUCERS
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_LIST: {
      return {
        ...state,
        payerList: {
          ...state.payerList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_LIST: {
      return {
        ...state,
        payerList: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_LIST_ERROR: {
      return {
        ...state,
        payerList: {
          ...state.payerList,
          loading: false,
          error: action.payload
        }
      };
    }

    //PAYER PROC COUNT LIST REDUCERS
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PROC_COUNT: {
      return {
        ...state,
        payerProcCount: {
          ...state.payerProcCount,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PROC_COUNT: {
      return {
        ...state,
        payerProcCount: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PROC_COUNT_ERROR: {
      return {
        ...state,
        payerList: {
          ...state.payerProcCount,
          loading: false,
          error: action.payload
        }
      };
    }

    /*FACILITY COMPETETIVE LANDSCAPE CATEGORY LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_CATEGORY_LIST: {
      return {
        ...state,
        categoryList: {
          ...state.categoryList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_CATEGORY_LIST: {
      return {
        ...state,
        categoryList: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_CATEGORY_LIST_ERROR: {
      return {
        ...state,
        categoryList: {
          ...state.categoryList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*HOSPITAL LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HOSPITAL_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_HOSPITAL_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          hospitalList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_HOSPITAL_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*ANCILLARY LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_ANCILLARY_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_ANCILLARY_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          ancillaryList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_ANCILLARY_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*NPI LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_NPI_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_NPI_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          npiList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_NPI_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROCEDURE CATEGORY REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_CATEGORY: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_CATEGORY: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          procCategoryList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_CATEGORY_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*BILLING CODE TYPE LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_BILLING_CODE_TYPE_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_BILLING_CODE_TYPE_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          codeTypeList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_BILLING_CODE_TYPE_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*LEVEL1 DESCIPTION LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_L1_DESCRIPTION: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_L1_DESCRIPTION: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          l1DescriptionList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_L1_DESCRIPTION_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROCEDURE NAME LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_NAME_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_NAME_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          procedureNameList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_NAME_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*MODIFIER LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_MODIFIER_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_MODIFIER_LIST: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          modifierList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_MODIFIER_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PAYER PRICE DIFF AVG LIST REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PRICE_DIFF_LIST: {
      return {
        ...state,
        priceDiffAvgList: {
          ...state.priceDiffAvgList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PRICE_DIFF_LIST: {
      const splittedData = transformData(action.payload.data);
      let tempData = [];
      for (const [key, value] of Object.entries(splittedData)) {
        tempData.push({
          label: key,
          priceCategoryList: setPriceCategoryList(value),
          priceDiffAvgChartList: setPriceDiffAvgChartList(value)
        });
      }
      const nego = tempData.find((val) => val.label === 'negotiated');
      const perdiem = tempData.find((val) => val.label === 'per diem');
      const filtered = tempData.filter((val) => val.label != 'negotiated' && val.label != 'per diem');
      return {
        ...state,
        priceDiffAvgList: {
          ...state.priceDiffAvgList,
          negotiatedTypes: action.payload.negotiatedTypes,
          data: action.payload.data,
          error: null,
          loading: false,
          combinedPriceDiffList: [...(nego ? [nego] : []), ...(perdiem ? [perdiem] : []), ...filtered]
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PRICE_DIFF_LIST_ERROR: {
      return {
        ...state,
        selectedFilterDataPayers: {
          ...state.selectedFilterDataPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*RESET PAYER PRICE COMP LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_PAYER_PRICE_COMP_LIST: {
      return {
        ...state,
        priceDiffAvgList: {
          ...state.priceDiffAvgList,
          data: [],
          negotiatedTypes: [],
          combinedPriceDiffList: []
        }
      };
    }

    /*RESET FILTERED DRG LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTERED_DRG_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          filterDrgListData: []
        }
      };
    }

    /*RESET FILTER STATE REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTER_STATE: {
      return {
        ...state,
        selectedFilterDataPayers: action.payload
      };
    }

    //FILTER DRG LIST REDUCER

    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTERED_DRG_LIST_FILTER_STATE: {
      return {
        ...state,
        filteredDRGList: action.payload
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGHOSPITAL_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGHOSPITAL_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          hospitalList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGHOSPITAL_LIST_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_ANCILLARY_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_ANCILLARY_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          ancillaryList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_ANCILLARY_LIST_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGPAYER_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGPAYER_LIST: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          payerList: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGPAYER_LIST_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODE_TYPE: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODE_TYPE: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          billingCodeType: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODE_TYPE_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODES: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODES: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          billingCode: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODES_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGLIST_DATA: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGLIST_DATA: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          filterDrgListData: splitHospitalWiseData(action.payload),
          filteredDRGRawData: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGLIST_DATA_ERROR: {
      return {
        ...state,
        filteredDRGList: {
          ...state.filteredDRGList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_COST_ALLENTITY: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_COST_ALLENTITY: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          allEntities: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_COST_ALLENTITY_ERROR: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_PROVIDER_NAME: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_PROVIDER_NAME: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          providerName: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_PROVIDER_NAME_ERROR: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_CODE_CATEGORY: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_CODE_CATEGORY: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          codeCategory: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_CODE_CATEGORY_ERROR: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_REPORTING_ENTITY_NAME: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_REPORTING_ENTITY_NAME: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          reportingEntityName: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_REPORTING_ENTITY_NAME_ERROR: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_BREAKDOWN: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_BREAKDOWN: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          drgBreakdown: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_BREAKDOWN_ERROR: {
      return {
        ...state,
        drgCostBreakDown: {
          ...state.drgCostBreakDown,
          loading: false,
          error: action.payload
        }
      };
    }

    /*STATE MAP DATA LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_STATE_MAP_DATA_LIST: {
      return {
        ...state,
        stateMapDataList: {
          ...state.stateMapDataList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_STATE_MAP_DATA_LIST: {
      return {
        ...state,
        stateMapDataList: {
          ...state.stateMapDataList,
          data: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_STATE_MAP_DATA_LIST_ERROR: {
      return {
        ...state,
        stateMapDataList: {
          ...state.stateMapDataList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*REGIONAL MAP DATA LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_REGIONAL_MAP_DATA_LIST: {
      return {
        ...state,
        regionalMapDataList: {
          ...state.regionalMapDataList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_REGIONAL_MAP_DATA_LIST: {
      return {
        ...state,
        regionalMapDataList: {
          ...state.regionalMapDataList,
          data: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_REGIONAL_MAP_DATA_LIST_ERROR: {
      return {
        ...state,
        regionalMapDataList: {
          ...state.regionalMapDataList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*SET SELECTED STATE REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_SELECTED_STATE: {
      return {
        ...state,
        selectedState: action.payload
      };
    }

    /*TOP PREF ENTITY LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PREF_ENTITY_LIST: {
      return {
        ...state,
        allPayers: {
          ...state.allPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PREF_ENTITY_LIST: {
      return {
        ...state,
        allPayers: {
          ...state.allPayers,
          data: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PREF_ENTITY_LIST_ERROR: {
      return {
        ...state,
        allPayers: {
          ...state.allPayers,
          loading: false,
          error: action.payload
        }
      };
    }

    /*OVERVIEW DRG LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_DRG_LIST: {
      return {
        ...state,
        topOverviewList: {
          ...state.allPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_DRG_LIST: {
      return {
        ...state,
        topOverviewList: {
          ...action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_DRG_LIST_ERROR: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*OVERVIEW CPT LIST REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_CPT_LIST: {
      return {
        ...state,
        topOverviewList: {
          ...state.allPayers,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_CPT_LIST: {
      return {
        ...state,
        topOverviewList: {
          ...action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_CPT_LIST_ERROR: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*TOP PROCEDURE L4 REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_L4: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_L4: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          topProceduresL4: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_L4_ERROR: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: false,
          error: action.payload
        }
      };
    }

    /*TOP PROCEDURE NON PREF L4 REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_NON_PREF_L4: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_NON_PREF_L4: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          toptopProceduresNotPrefL4: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_NON_PREF_L4_ERROR: {
      return {
        ...state,
        topOverviewList: {
          ...state.topOverviewList,
          loading: false,
          error: action.payload
        }
      };
    }

    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_DRG_COST_FILTER_STATE: {
      return {
        ...state,
        drgCostBreakDown: action.payload
      };
    }

    /*HISTORICAL REQUESTS REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HISTORICAL_REQUESTS: {
      return {
        ...state,
        historicalRequests: {
          ...state.historicalRequests,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_HISTORICAL_REQUESTS: {
      return {
        ...state,
        historicalRequests: {
          data: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_HISTORICAL_REQUESTS_ERROR: {
      return {
        ...state,
        historicalRequests: {
          ...state.historicalRequests,
          loading: false,
          error: action.payload
        }
      };
    }

    /*HISTORICAL REQUESTS REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PLACE_RE_REQUEST: {
      return {
        ...state,
        reRequest: {
          ...state.reRequest,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PLACE_RE_REQUEST: {
      return {
        ...state,
        reRequest: {
          message: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PLACE_RE_REQUEST_ERROR: {
      return {
        ...state,
        reRequest: {
          ...state.reRequest,
          loading: false,
          error: action.payload
        }
      };
    }

    /*FACILITY SCORECARD SCORES REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_SCORES: {
      return {
        ...state,
        facilityScoreCardScore: {
          ...state.facilityScoreCardScore,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_SCORES: {
      return {
        ...state,
        facilityScoreCardScore: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_SCORES_ERROR: {
      return {
        ...state,
        facilityScoreCardScore: {
          ...state.facilityScoreCardScore,
          loading: false,
          error: action.payload
        }
      };
    }

    /*FACILITY SCORECARD NPIS REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_NPIS: {
      return {
        ...state,
        facilityScoreCardnpiData: {
          ...state.facilityScoreCardnpiData,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_NPIS: {
      return {
        ...state,
        facilityScoreCardnpiData: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_NPIS_ERROR: {
      return {
        ...state,
        facilityScoreCardnpiData: {
          ...state.facilityScoreCardnpiData,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROVIDERS EXTRACT FILTERS REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_FILTERS: {
      return {
        ...state,
        providerExtractFilters: {
          ...state.providerExtractFilters,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_FILTERS: {
      return {
        ...state,
        providerExtractFilters: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_FILTERS_ERROR: {
      return {
        ...state,
        providerExtractFilters: {
          ...state.providerExtractFilters,
          loading: false,
          error: action.payload
        }
      };
    }

    /*RESET PROVIDERS EXTRACT RESULT REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_PROVIDERS_EXTRACT_RESULT: {
      return {
        ...state,
        providerExtractResult: {
          ...state.providerExtractResult,
          data: []
        }
      };
    }

    /*RESET PROVIDERS EXTRACT CHART RESULT REDUCER*/
    case FACILITY_AND_ANCILLARY_ACTIONS.RESET_PROVIDERS_EXTRACT_CHART_RESULT: {
      return {
        ...state,
        providerExtractChartResult: {
          ...state.providerExtractChartResult,
          data: []
        }
      };
    }

    /*PROVIDERS EXTRACT RESULT REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT: {
      return {
        ...state,
        providerExtractResult: {
          ...state.providerExtractResult,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT: {
      return {
        ...state,
        providerExtractResult: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_ERROR: {
      return {
        ...state,
        providerExtractResult: {
          ...state.providerExtractResult,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROVIDERS EXTRACT RESULT CHARTS REDUCERS*/
    case FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT_CHARTS: {
      return {
        ...state,
        providerExtractChartResult: {
          ...state.providerExtractChartResult,
          loading: true,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_CHARTS: {
      return {
        ...state,
        providerExtractChartResult: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_CHARTS_ERROR: {
      return {
        ...state,
        providerExtractChartResult: {
          ...state.providerExtractChartResult,
          loading: false,
          error: action.payload
        }
      };
    }

    default: {
      return { ...state };
    }
  }
};

export default ancillaryAndFacility;
